module.exports = __webpack_public_path__ + "4c124747f75e30168f7d529869b497cc.pdf";